import { ICamera } from '@api/models';
import { enableBim } from '@api/services/camera.service';
import CustomSwitch from '@components/FormFields/CustomSwitch';
import { Button, Label } from '@hyperflake/react-ui-library';
import { FormHelperText } from '@library/forms';
import { ErrorMessage, Form, Formik } from 'formik';
import { FormikInput } from 'modules/shared/features/formik';
import { toast } from 'react-toastify';

interface ICameraBimFormProps {
    camera?: ICamera;
    clientId?: string;
    projectId?: string;
    onCameraUpdate?: (camera: ICamera) => void;
}

const CameraBimForm = (props: ICameraBimFormProps) => {
    const { camera, clientId, projectId, onCameraUpdate } = props;
    const handleSubmit = async (values: any) => {
        const payloadUrn = {
            urn: values.urn,
        };
        try {
            const data = await enableBim(clientId, projectId, camera._id, payloadUrn);
            onCameraUpdate(data);
            toast.success('Bim Enabled');
        } catch (ex: any) {
            toast.error(ex?.data?.message || 'Some error occured, please try again.');
            console.log(ex);
        }
    };
    let initialValues = {
        isUrn: false,
        urn: '',

        // isUrn:camera.urn?true:false,
        // urn: camera.urn | "";
    };
    return (
        <div>
            <div className="font-medium">BIM</div>
            <Formik
                initialValues={initialValues}
                enableReinitialize
                // validationSchema={updateClientForm.schema}
                onSubmit={handleSubmit}
            >
                {({ values, setFieldValue }) => (
                    <Form>
                        {/* <fieldset disabled={!hasAdminPermission}> */}
                        <div className=" flex flex-col gap-2 mt-2 p-4">
                            <div className="">
                                <Label>Enter Urn</Label>
                                <FormikInput type="text" name="urn" disabled={!values.isUrn} placeholder="Enter Urn" />
                                <FormHelperText variant={'error'}>
                                    <ErrorMessage name="urn" />
                                </FormHelperText>
                            </div>
                            <div className="pb-2">
                                <CustomSwitch
                                    // key={index}
                                    name={`isUrn`}
                                    label={'Enable BIM'}
                                />
                            </div>

                            <div className="w-full md:w-auto flex justify-start ">
                                <Button
                                    type="submit"
                                    size={'sm'}
                                    className="w-full md:w-auto"
                                    disabled={values.urn === ''}
                                >
                                    {/* {updatePulginForm.isSubmitting ? <CircularProgress color={'inherit'} size={18} /> : 'Save'} */}
                                    Save
                                </Button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default CameraBimForm;
